module.exports = __webpack_public_path__ + "static/residential1thumb-67fb79986eb8e5692754b54f8a1a8a60.jpg";